if (!customElements.get('tcl-countdown-controller')) {
  customElements.define('tcl-countdown-controller', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.root = document.getElementById(this.dataset.target);
        if (!this.root) return;
        this.end = new Date(this.root.dataset.countdownEnd).getTime();
        this.fields = ['d', 'h', 'm', 's'].map(name => this.root.querySelector(`.${name}`));
        if (this.fields.some(field => !field)) return;
        if (this.tick()) this.timer = setInterval(() => this.tick(), 1000);
      });
    }

    tick() {
      const remaining = this.end - Date.now();
      if (!Number.isFinite(remaining) || remaining <= 0) {
        this.root.style.display = 'none';
        clearInterval(this.timer);
        this.timer = null;
        return false;
      }
      this.root.style.display = '';
      const seconds = Math.floor(remaining / 1000);
      const values = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24,
        Math.floor(seconds / 60) % 60, seconds % 60];
      this.fields.forEach((field, index) => { field.textContent = String(values[index]).padStart(2, '0'); });
      return true;
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      clearInterval(this.timer);
      this.frame = null;
      this.timer = null;
      this.root = null;
      this.fields = null;
    }
  });
}
